/* Categoriepagina's accessoires (blok B): normaliseren, filteren, tellen en sorteren over de VOLLEDIGE set vóór paginering.
   Alleen bestaande gestructureerde winkeldata: tags, vendor (alleen als die een merk is), metafields en varianten.
   Geen eigenschappen uit de producttitel. Een ontbrekend veld is "onbekend", nooit "nee": zo'n product telt niet mee
   bij een gekozen waarde, maar blijft zichtbaar zolang die groep niet gekozen is.
   Verkoopbaar = variant beschikbaar én voorraad bijgehouden én hoeveelheid > 0 (bestaande strikte regel). */
(function (root, factory) {
  const core = factory();
  if (typeof module === 'object' && module.exports) module.exports = core;
  else root.PrimeFoneCategory = core;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';
  const list = v => Array.isArray(v) ? v : v == null || v === '' ? [] : [v];
  const norm = v => String(v || '').trim().toLocaleLowerCase('nl');
  const unique = a => [...new Set(a)];
  const sellable = v => v.available === true && v.tracked === true && Number(v.quantity) > 0;

  // Merken: vendor als die een merk is; anders (leverancier, bijv. "Onestop Mobile") één merk uit de tags. Tag "Apple" betekent
  // meestal "voor Apple" en telt daarom alleen als merk wanneer de vendor zelf Apple is.
  const BRANDS = {'speck': 'Speck', 'decoded': 'Decoded', 'nudient': 'Nudient', 'otterbox': 'OtterBox', 'care by panzerglass': 'CARE by PanzerGlass', 'panzerglass': 'PanzerGlass', 'burga': 'Burga', 'cygnett': 'Cygnett', 'mobiparts': 'Mobiparts', 'apple': 'Apple'};
  function brandOf(p) {
    const v = BRANDS[norm(p.vendor)];
    if (v) return v;
    // Een merk uit de tags geldt alleen als de titel dat merk ook noemt (tegenspraakcontrole; bijv. tag "Burga" op een PanzerGlass-product).
    const fromTags = unique(list(p.tags).map(t => BRANDS[norm(t)]).filter(b => b && b !== 'Apple'));
    return fromTags.length === 1 && norm(p.title).includes(norm(fromTags[0]).replace(/^care by /, '')) ? fromTags[0] : '';
  }

  // Exact model uit een modeltag ("iPhone 16 Pro Hoesjes", "iPhone 17 Air Hoesjes", "iPhone 11 Tempered Glass"); serietags tellen niet.
  const MODEL_TAG = /^(?:Apple )?iPhone (\d{1,2}e?|Air|SE|X[RS]?)(?: (Air|Pro Max|Pro|Plus|Max|mini))? (?:Hoesjes|Hoesje|Screen Protectors?|Tempered Glass|Privacy Protectors)$/i;
  function modelsOf(p) {
    const out = [];
    for (const tag of list(p.tags)) {
      if (/serie/i.test(tag)) continue;
      const m = String(tag).trim().match(MODEL_TAG);
      if (!m) continue;
      let name = 'iPhone ' + m[1].replace(/^x/i, 'X').replace(/^XR$/i, 'XR').replace(/^XS$/i, 'XS').replace(/^se$/i, 'SE');
      let suffix = m[2] || '';
      if (suffix) suffix = ({'pro max': 'Pro Max', 'pro': 'Pro', 'plus': 'Plus', 'max': 'Max', 'mini': 'mini', 'air': 'Air'})[norm(suffix)];
      if (suffix === 'Air') { name = 'iPhone Air'; suffix = ''; }
      out.push(suffix ? name + ' ' + suffix : name);
    }
    return unique(out);
  }

  // Blok X: custom.past_op (lijst iphone_model, in de feed als namen) is de beheerde bron en gaat voor op de modeltags.
  // Leeg of ontbrekend = terugval op modeltags + titelcontrole (ongewijzigd gedrag).
  function pastOf(p) { return unique(list(p.mf && p.mf.past_op).map(s => String(s || '').trim()).filter(Boolean)); }

  // Tegenspraakcontrole (geen bron): welke iPhones noemt de titel? Noemt de titel iPhones en valt een modeltag daarbuiten,
  // dan spreken titel en tag elkaar tegen en blijft het model onbekend (geen modelchip, niet in de modelfilter).
  const TITLE_MODELS = /iPhone\s+((?:\d{1,2}e?|Air|SE|X[RS]?)(?:\s+(?:Pro Max|Pro|Plus|Max|mini|Air))?(?:\s*\/\s*(?:\d{1,2}e?|Air|SE|X[RS]?)(?:\s+(?:Pro Max|Pro|Plus|Max|mini|Air))?)*)/i;
  function titleModels(title) {
    const m = String(title || '').match(TITLE_MODELS);
    if (!m) return [];
    return m[1].split('/').map(t => t.trim().replace(/\s+/g, ' ')).filter(Boolean).map(t => {
      let [num, ...rest] = t.split(' ');
      let suffix = rest.join(' ');
      num = /^x/i.test(num) ? num.toUpperCase() : /^se$/i.test(num) ? 'SE' : /^air$/i.test(num) ? 'Air' : num.toLowerCase();
      if (norm(suffix) === 'air') return 'iPhone Air';
      suffix = suffix ? ({'pro max': 'Pro Max', 'pro': 'Pro', 'plus': 'Plus', 'max': 'Max', 'mini': 'mini'})[norm(suffix)] || suffix : '';
      return 'iPhone ' + num + (suffix ? ' ' + suffix : '');
    });
  }
  function titleAgrees(title, models) {
    const named = titleModels(title);
    return !named.length || models.every(m => named.includes(m));
  }

  const plain = s => norm(s).replace(/[-_/]/g, ' ').replace(/\s+/g, ' ');
  function connAgrees(title, conn) {
    const t = plain(title);
    if (!/usb|lightning|lighting|micro|type c/.test(t)) return true;
    const usbC = (t.match(/usb ?c\b|type c\b/g) || []).length;
    if (conn === 'USB-C ↔ USB-C') return usbC >= 2;
    if (conn === 'USB-A ↔ USB-C') return usbC >= 1 && /usb ?a\b/.test(t);
    if (conn === 'Lightning') return /lightning|lighting/.test(t); // 'Lighting' = bestaande typfout in een leverancierstitel
    if (conn === 'Micro-USB') return /micro ?usb/.test(t);
    return false;
  }
  function kindAgrees(title, kind) {
    const t = plain(title);
    if (kind === 'Stopcontact') return /wall|power adapter|home charger|travel/.test(t);
    if (kind === 'Auto') return /\bcar\b|carpower/.test(t);
    if (kind === 'Draadloos') return /wireless|magsafe/.test(t);
    if (kind === '3-in-1') return /3 in 1/.test(t);
    return false;
  }

  // Houders: een soort-tag geldt alleen als de titel die soort niet tegenspreekt (bijv. tag "Card Houders" op een autohouder).
  function holderAgrees(title, kind) {
    const t = plain(title);
    if (kind === 'Auto') return /\bcar\b|vehicle|vent/.test(t);
    if (kind === 'Fiets') return /\bbike\b|fiets/.test(t);
    if (kind === 'Ring') return /\bring\b/.test(t);
    if (kind === 'Pasjes') return /\bcard\b|pasje/.test(t);
    if (kind === 'Standaard') return /\bstand\b/.test(t);
    if (kind === 'Zuignap') return /suction|zuig/.test(t);
    return false;
  }

  // Volgorde van modellen in filters en kiezer (nieuw → oud), gelijk aan de modelkiezer van de productpagina.
  const MODEL_ORDER = ['iPhone 18 Pro Max', 'iPhone 18 Pro', 'iPhone 17 Pro Max', 'iPhone 17 Pro', 'iPhone Air', 'iPhone 17', 'iPhone 16 Pro Max', 'iPhone 16 Pro', 'iPhone 16 Plus', 'iPhone 16', 'iPhone 16e', 'iPhone 15 Pro Max', 'iPhone 15 Pro', 'iPhone 15 Plus', 'iPhone 15', 'iPhone 14 Pro Max', 'iPhone 14 Pro', 'iPhone 14 Plus', 'iPhone 14', 'iPhone 13 Pro Max', 'iPhone 13 Pro', 'iPhone 13', 'iPhone 13 mini', 'iPhone 12 Pro Max', 'iPhone 12 Pro', 'iPhone 12', 'iPhone 12 mini', 'iPhone SE (2022)', 'iPhone SE (2020)', 'iPhone 11 Pro Max', 'iPhone 11 Pro', 'iPhone 11', 'iPhone XS Max', 'iPhone XS', 'iPhone XR', 'iPhone X'];
  const modelRank = m => { const i = MODEL_ORDER.indexOf(m); return i < 0 ? 999 : i; };

  const has = (p, re) => list(p.tags).some(t => re.test(String(t).trim()));
  const MATERIAL = {'tpu': 'TPU', 'siliconen': 'Siliconen', 'silicone': 'Siliconen', 'leer': 'Leer', 'leather': 'Leer', 'textiel': 'Textiel'};

  // Per categorie: welke groepen er zijn, hun waarden (uit gestructureerde data) en snelfilters.
  const CATEGORIES = {
    'telefoon-hoesjes': {
      noun: ['hoesje', 'hoesjes'], groups: ['model', 'type', 'props', 'material', 'brand', 'price'],
      quick: [['props', 'MagSafe'], ['props', 'Transparant'], ['material', 'Leer'], ['type', 'Wallet']],
      derive(p) {
        const type = list(p.mf && p.mf.type).map(norm);
        const types = [];
        if (type.includes('wallet case') || has(p, /^leather detachable wallet$/i)) types.push('Wallet');
        if (type.includes('backcover')) types.push('Backcover');
        const props = [];
        const mag = list(p.mf && p.mf.magsafe).map(norm);
        // Blok X: custom.magsafe (boolean) gaat voor; null = terugval op de oude tekstwaarde.
        if (p.mf && p.mf.magsafe_bool === true) props.push('MagSafe');
        else if (!(p.mf && p.mf.magsafe_bool === false) && mag.includes('met magsafe')) props.push('MagSafe');
        if (type.includes('transparent')) props.push('Transparant');
        const material = unique(list(p.mf && p.mf.material).map(m => MATERIAL[norm(m)]).filter(Boolean));
        return {type: types, props, material};
      }
    },
    'screenprotectors': {
      noun: ['screenprotector', 'screenprotectors'], groups: ['model', 'type', 'brand', 'price'],
      quick: [['type', 'Privacy'], ['type', 'Ultra Wide Fit'], ['type', 'Ceramic'], ['type', 'Gehard glas']],
      derive(p) {
        const types = [];
        if (has(p, /privacy protectors?$/i)) types.push('Privacy');
        if (has(p, /^ultra wide fit screen protectors?$/i)) types.push('Ultra Wide Fit');
        if (has(p, /^classic fit screen protectors?$/i)) types.push('Classic Fit');
        if (has(p, /^ceramic screen protectors?$/i)) types.push('Ceramic');
        if (has(p, /^gehard glas protectors?$/i) || has(p, /tempered glass$/i)) types.push('Gehard glas');
        const mat = list(p.mf && p.mf.material).map(norm);
        // custom.material alleen als de titel het niet tegenspreekt (gekopieerde leveranciersdata komt voor).
        const tt = plain(p.title);
        if (mat.includes('privacy glass') && /privacy/.test(tt)) types.push('Privacy');
        if (mat.includes('ultra wide fit') && /ultra wide/.test(tt)) types.push('Ultra Wide Fit');
        if (mat.includes('gehard glas screenprotector') && /glas|glass/.test(tt)) types.push('Gehard glas');
        return {type: unique(types)};
      }
    },
    'kabels': {
      noun: ['kabel', 'kabels'], groups: ['port', 'side', 'conn', 'props', 'brand', 'price'],
      quick: [['conn', 'USB-C ↔ USB-C'], ['conn', 'USB-A ↔ USB-C'], ['conn', 'Lightning'], ['props', 'Gevlochten']],
      derive(p) {
        let conn = [];
        if (has(p, /^usb c to usb c kabels?$/i)) conn.push('USB-C ↔ USB-C');
        if (has(p, /^usb a to usb c kabels?$/i) || has(p, /^usb c to usb a kabels?$/i)) conn.push('USB-A ↔ USB-C');
        if (has(p, /^lightning kabels?$/i)) conn.push('Lightning');
        if (has(p, /^micro usb kabels?$/i)) conn.push('Micro-USB');
        // Autoladers met meegeleverde kabel zijn geen losse kabel: geen kabeltype, aansluiting of laderkant (één regel voor alle soorten).
        const carCharger = has(p, /^car chargers?( dual)?$/i) || /\bcar charger\b/i.test(p.title || '');
        conn = carCharger ? [] : conn.filter(c => connAgrees(p.title, c));
        const props = [];
        if (has(p, /^braided kabels?$/i)) props.push('Gevlochten');
        // Aansluiting iPhone: USB-C (USB-C/USB-A naar USB-C) of Lightning. Kant van de lader: USB-C of USB-A.
        const port = [], side = [];
        if (!carCharger && conn.includes('USB-C ↔ USB-C')) { port.push('USB-C'); side.push('USB-C'); }
        if (!carCharger && conn.includes('USB-A ↔ USB-C')) { port.push('USB-C'); side.push('USB-A'); }
        if (!carCharger && conn.includes('Lightning')) {
          port.push('Lightning');
          if (has(p, /^usb c kabels?$/i)) side.push('USB-C'); else if (has(p, /^usb kabels?$/i)) side.push('USB-A');
        }
        return {conn, props, port: unique(port), side: unique(side)};
      }
    },
    'laders': {
      noun: ['adapter', 'adapters'], groups: ['kind', 'props', 'brand', 'price'],
      quick: [['kind', 'Stopcontact'], ['kind', 'Auto'], ['kind', 'Draadloos']],
      derive(p) {
        const kind = [];
        if (has(p, /^wall chargers?$/i)) kind.push('Stopcontact');
        if (has(p, /^car chargers?( dual)?$/i)) kind.push('Auto');
        if (has(p, /^wireless chargers?$/i)) kind.push('Draadloos');
        if (has(p, /^3 in 1 chargers?$/i)) kind.push('3-in-1');
        const props = [];
        if ((has(p, /^dual usb chargers?$/i) || has(p, /^car chargers? dual$/i)) && /dual|2 port|x2/.test(plain(p.title))) props.push('Twee poorten');
        return {kind: unique(kind).filter(k => kindAgrees(p.title, k)), props};
      }
    },
    'powerbanks': {
      noun: ['powerbank', 'powerbanks'], groups: ['brand', 'price'], quick: [['brand', 'Cygnett'], ['brand', 'Decoded'], ['brand', 'Mobiparts'], ['brand', 'OtterBox']],
      derive() { return {}; }
    },
    'houders': {
      noun: ['houder', 'houders'], groups: ['kind', 'props', 'brand', 'price'],
      quick: [['props', 'MagSafe'], ['kind', 'Auto'], ['kind', 'Ring'], ['kind', 'Pasjes']],
      derive(p) {
        const kind = [];
        if (has(p, /^car holders?$/i)) kind.push('Auto');
        if (has(p, /^bike houders?$/i)) kind.push('Fiets');
        if (has(p, /^(magsafe )?ring houders?$/i)) kind.push('Ring');
        if (has(p, /^card houders?$/i)) kind.push('Pasjes');
        if (has(p, /^(magsafe stands?|(phone|tablet|laptop) stand houders?)$/i)) kind.push('Standaard');
        if (has(p, /^vac?cuum suction houders?$/i)) kind.push('Zuignap');
        const props = [];
        if (p.mf && p.mf.magsafe_bool === true) props.push('MagSafe');
        else if (!(p.mf && p.mf.magsafe_bool === false) && has(p, /^magsafe (houders|stands?)$/i) && /magsafe/.test(plain(p.title))) props.push('MagSafe');
        return {kind: unique(kind).filter(k => holderAgrees(p.title, k)), props};
      }
    }
  };
  const GROUP_LABELS = {model: 'Geschikt voor', type: 'Type', props: 'Eigenschappen', material: 'Materiaal', brand: 'Merk', conn: 'Aansluiting', kind: 'Soort', port: 'Aansluiting iPhone', side: 'Kant van de lader', price: 'Prijs'};
  const VALUE_GROUPS = ['model', 'type', 'props', 'material', 'brand', 'conn', 'kind', 'port', 'side'];
  const SORTS = ['best-selling', 'price-ascending', 'price-descending', 'created-descending', 'title-ascending'];

  // Weergavenaam: merk staat apart boven de naam, dus een merk vooraan valt weg; "Apple " vóór "iPhone" ook. Verder letterlijk.
  function shortTitle(title, brand) {
    let t = String(title || '').trim();
    if (brand && norm(t).startsWith(norm(brand) + ' ')) t = t.slice(brand.length + 1);
    return t.replace(/\bApple (iPhone|iPad|AirPods|Watch)\b/g, '$1').replace(/\s+-\s+$/, '').trim();
  }

  function hydrate(handle, products) {
    const cat = CATEGORIES[handle];
    if (!cat) throw new Error('Onbekende categorie');
    const rows = [];
    products.forEach((p, rank) => {
      if (p.complete === false) throw new Error('De uitvoeringen van een product zijn niet volledig geladen.');
      const variants = list(p.variants).filter(sellable);
      if (!variants.length) return;
      const brand = brandOf(p);
      const extra = cat.derive(p);
      const prices = variants.map(v => Number(v.price));
      const single = list(p.variants).length === 1 && variants.length === 1;
      rows.push({
        id: String(p.id), url: p.url, title: p.title, name: shortTitle(p.title, brand), image: p.image || '', created: Number(p.created) || 0, rank,
        brand, model: cat.groups.includes('model') ? (pastOf(p).length ? pastOf(p) : (m => titleAgrees(p.title, m) ? m : [])(modelsOf(p))).sort((a, b) => modelRank(a) - modelRank(b)) : [],
        type: extra.type || [], props: extra.props || [], material: extra.material || [], conn: extra.conn || [], kind: extra.kind || [], port: extra.port || [], side: extra.side || [],
        price: Math.min(...prices), priceFrom: !single && unique(prices).length > 1,
        cartVariant: single ? String(variants[0].id) : '', variantCount: list(p.variants).length
      });
    });
    return {handle, rows, config: cat};
  }

  const empty = () => ({model: [], type: [], props: [], material: [], brand: [], conn: [], kind: [], port: [], side: [], min: '', max: '', sort: 'best-selling', layout: 'grid', n: 0});
  const valuesOf = (row, group) => group === 'brand' ? (row.brand ? [row.brand] : []) : row[group] || [];

  function matches(row, state, skip) {
    for (const g of VALUE_GROUPS) {
      if (g === skip || !state[g] || !state[g].length) continue;
      const vals = valuesOf(row, g);
      if (g === 'props') { if (!state.props.every(v => vals.includes(v))) return false; }
      else if (!state[g].some(v => vals.includes(v))) return false;
    }
    if (skip !== 'price') {
      const min = state.min === '' ? null : Number(state.min) * 100, max = state.max === '' ? null : Number(state.max) * 100;
      if (min !== null && row.price < min) return false;
      if (max !== null && row.price > max) return false;
    }
    return true;
  }
  function sortRows(rows, sort) {
    const r = rows.slice();
    const cmp = {
      'best-selling': (a, b) => a.rank - b.rank,
      'price-ascending': (a, b) => a.price - b.price || a.rank - b.rank,
      'price-descending': (a, b) => b.price - a.price || a.rank - b.rank,
      'created-descending': (a, b) => b.created - a.created || a.rank - b.rank,
      'title-ascending': (a, b) => a.name.localeCompare(b.name, 'nl') || a.rank - b.rank
    }[sort] || ((a, b) => a.rank - b.rank);
    return r.sort(cmp);
  }
  function apply(rows, state) { return sortRows(rows.filter(r => matches(r, state)), state.sort); }

  // Facetten: per groep de waarden met aantallen, berekend met alle ándere gekozen filters (vóór paginering).
  function facets(rows, state, groups) {
    const out = {};
    for (const g of groups) {
      if (g === 'price') continue;
      const base = rows.filter(r => matches(r, state, g));
      const counts = new Map();
      if (g === 'props') {
        // Eigenschappen combineren met EN: per eigenschap het aantal dat óók aan de al gekozen eigenschappen voldoet.
        unique(rows.flatMap(r => r.props)).forEach(v => counts.set(v, base.filter(r => unique(state.props.concat(v)).every(x => r.props.includes(x))).length));
      } else {
        base.forEach(r => valuesOf(r, g).forEach(v => counts.set(v, (counts.get(v) || 0) + 1)));
      }
      // Gekozen waarden blijven zichtbaar, ook bij 0.
      (state[g] || []).forEach(v => { if (!counts.has(v)) counts.set(v, 0); });
      let entries = [...counts.entries()];
      if (g === 'model') entries.sort((a, b) => modelRank(a[0]) - modelRank(b[0]) || a[0].localeCompare(b[0]));
      else entries.sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0], 'nl'));
      const known = rows.filter(r => valuesOf(r, g).length).length;
      out[g] = {values: entries.map(([value, count]) => ({value, count})), known, unknown: rows.length - known};
    }
    return out;
  }
  function priceRange(rows) {
    if (!rows.length) return {min: 0, max: 0};
    return {min: Math.floor(Math.min(...rows.map(r => r.price)) / 100), max: Math.ceil(Math.max(...rows.map(r => r.price)) / 100)};
  }

  const PARAMS = {model: 'pf_model', type: 'pf_type', props: 'pf_prop', material: 'pf_mat', brand: 'pf_brand', conn: 'pf_conn', kind: 'pf_kind', port: 'pf_port', side: 'pf_side'};
  function readState(search, groups) {
    const q = new URLSearchParams(search), s = empty();
    for (const g of VALUE_GROUPS) if (groups.includes(g)) s[g] = unique(q.getAll(PARAMS[g]).map(v => v.trim()).filter(Boolean));
    const num = v => /^\d+(\.\d+)?$/.test(v || '') ? String(Math.round(Number(v))) : '';
    s.min = num(q.get('pf_min')); s.max = num(q.get('pf_max'));
    s.sort = SORTS.includes(q.get('sort_by')) ? q.get('sort_by') : 'best-selling';
    s.layout = q.get('pf_layout') === 'list' ? 'list' : 'grid';
    s.n = /^\d+$/.test(q.get('pf_n') || '') ? Number(q.get('pf_n')) : 0;
    return s;
  }
  function writeState(state, base) {
    const q = new URLSearchParams(base || '');
    Object.values(PARAMS).concat(['pf_min', 'pf_max', 'sort_by', 'pf_layout', 'pf_n', 'page']).forEach(k => q.delete(k));
    for (const g of VALUE_GROUPS) (state[g] || []).forEach(v => q.append(PARAMS[g], v));
    if (state.min !== '') q.set('pf_min', state.min);
    if (state.max !== '') q.set('pf_max', state.max);
    if (state.sort !== 'best-selling') q.set('sort_by', state.sort);
    if (state.layout === 'list') q.set('pf_layout', 'list');
    if (state.n) q.set('pf_n', String(state.n));
    const s = q.toString();
    return s ? '?' + s : '';
  }
  const activeCount = state => VALUE_GROUPS.reduce((n, g) => n + (state[g] || []).length, 0) + (state.min !== '' || state.max !== '' ? 1 : 0);

  return {titleModels, titleAgrees, connAgrees, kindAgrees, CATEGORIES, GROUP_LABELS, VALUE_GROUPS, MODEL_ORDER, SORTS, brandOf, modelsOf, shortTitle, hydrate, apply, facets, priceRange, matches, empty, readState, writeState, activeCount, sellable};
});
